import { bonus } from './bonus.translation';
import { common } from './common.translation';

export const EN_US = {
  translation: {
    ...common,
    ...bonus,
  },
};
